import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Plan } from "../../features/plan-management-module/planAction";

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedPlan: Plan | null;
  handleDeleteConfirm: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  onClose,
  selectedPlan,
  handleDeleteConfirm,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
          backgroundColor: "linear-gradient(135deg, #edefee 0%, #fcfbf9 100%)",
          [theme.breakpoints.down("sm")]: {
            margin: "16px",
            width: "calc(100% - 32px)",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "#f5f0e7",
          backgroundColor: "#4b5b5d",
          fontWeight: 700,
          fontSize: "1.5rem",
          py: 2,
          px: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Confirm Delete
        <IconButton
          onClick={onClose}
          sx={{
            color: "#f5f0e7",
            "&:hover": {
              backgroundColor: "rgba(75, 91, 93, 0.1)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          mt: 4,
          p: 4,
          backgroundColor: "linear-gradient(135deg, #edefee 0%, #fcfbf9 100%)",
          [theme.breakpoints.down("sm")]: {
            mt: 2,
            p: 3,
          },
        }}
      >
        <Typography
          variant="body1"
          color="#4b5b5d"
          sx={{
            lineHeight: 1.6,
          }}
        >
          Are you sure you want to delete the plan "{selectedPlan?.planName}"?
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          backgroundColor: "#f5f0e7",
          borderTop: "1px solid rgba(75, 91, 93, 0.2)",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderColor: "#4b5b5d",
            color: "#4b5b5d",
            borderRadius: "8px",
            fontWeight: 600,
            px: 3,
            "&:hover": {
              backgroundColor: "rgba(75, 91, 93, 0.1)",
              borderColor: "#4b5b5d",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#d32f2f",
            color: "#f5f0e7",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            "&:hover": {
              backgroundColor: "#b71c1c",
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
